export default function auth({ next, router }) {
  if (!localStorage.getItem("glow_up_dashboard_user_token")) {
    return router.push("/");
  }
  return next();
}
